import React from 'react';
import PropTypes from 'prop-types';

const BUTTON_COLORS_MAP = {
  secondary: {
    backgroundColor: '#FFFFFF',
    border: 'solid 0.5px #424f62',
    color: '#424f62',
  },
  primary: {
    backgroundColor: '#424f62',
    border: 'solid 1px #424f62',
    color: '#FFFFFF',
  },
  tertiary: {
    backgroundColor: 'rgba(66, 79, 98, 0.12)',
    border: '0px',
    color: '#424f62',
  },
  light: {
    backgroundColor: '#FFFFFF',
    border: '0px',
    color: '#424f62',
  },
};

const BUTTON_SIZE_MAP = {
  large: {
    buttonHeight: '32px',
    buttonPadding: '7px',
    svgWidth: '16px',
    svgHeight: '16px',
    labelFontSize: '14px',
    labelMarginLeft: '5px',
    labelMarginRight: '5px',
    borderRadius: '4px',
  },
  medium: {
    buttonHeight: '24px',
    buttonPadding: '3px',
    svgWidth: '11px',
    svgHeight: '8px',
    labelFontSize: '12px',
    labelMarginLeft: '5px',
    labelMarginRight: '5px',
    borderRadius: '2px',
  },
};

const Joyn2Button = React.memo(function Joyn2Button({
  width,
  svg,
  label,
  onClick,
  btnType,
  margin,
  float,
  icon,
  size,
  type,
  disabled = false,
}) {
  const { backgroundColor, border, color } = BUTTON_COLORS_MAP[btnType || 'primary'];
  const {
    buttonHeight,
    buttonPadding,
    svgWidth,
    svgHeight,
    labelFontSize,
    labelMarginLeft,
    labelMarginRight,
    borderRadius,
  } = BUTTON_SIZE_MAP[size || 'large'];
  return (
    // eslint-disable-next-line react/button-has-type
    <button
      style={{
        width,
        height: buttonHeight,
        border,
        backgroundColor,
        color,
        borderRadius,
        padding: buttonPadding,
        margin,
        float,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disabled={disabled}
      type={type === 'submit' ? 'submit' : 'button'}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {svg && (
        <img
          style={{ width: svgWidth, height: svgHeight }}
          src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.icon)}`}
          alt="Discard"
        />
      )}
      {icon && <i className={icon.class} style={{ margin: icon.margin }} />}
      {label && (
        <span
          style={{
            fontSize: labelFontSize,
            color,
            marginLeft: labelMarginLeft,
            marginRight: labelMarginRight,
            fontWeight: 500,
          }}
        >
          {label}
        </span>
      )}
    </button>
  );
});

Joyn2Button.propTypes = {
  btnType: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'light']),
  size: PropTypes.oneOf(['large', 'medium']),
  icon: PropTypes.shape({
    class: PropTypes.string,
    margin: PropTypes.any,
  }),
  svg: PropTypes.shape({
    icon: PropTypes.string,
  }),
  width: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  margin: PropTypes.any,
  float: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Joyn2Button;
